import React from "react";
import "./NavLinkCard.css";
import { useNavigate, useLocation } from "react-router-dom";

function NavlinkCard({ item, handleNavCardClick, show }) {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <div id="NavlinkCard">
      <li key={item.id}>
        {location.pathname === "/shop" ? (
          <a
            onClick={() => {
              handleNavCardClick();
              navigate(`/${item.toLink}`);
            }}
          >
            <div className="nav_link">
              <div className="nav_icon">{item.icon}</div>
              <div className="nav_name">{`${item.name}`}</div>
            </div>
          </a>
        ) : (
          <a href={item.toLink}>
            <div className="nav_link" onClick={handleNavCardClick}>
              <div className="nav_icon">{item.icon}</div>
              <div className="nav_name">{`${item.name}`}</div>
            </div>
          </a>
        )}
      </li>
    </div>
  );
}

export default NavlinkCard;
